module.exports = __webpack_public_path__ + "img/img_customers_03.a830921c.png";